import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_PATIENT } from "../../config/connString";
import useAxios from "../../utils/useAxios";
import decodedUserDetails from "../../utils/decodedUserDetails";
import moment from "moment";
import { isDataEmpty } from "utils/isDataEmpty";

const createPatient = createAsyncThunk(
  "patients/create-patient",
  async (data) => {
    try {
      const clientId = decodedUserDetails()?.clientId;
      const api = useAxios();

      const response = await api.post(URL_PATIENT, {
        firstname: data?.firstname,
        lastname: data?.lastname,
        middlename: data?.middlename ? data?.middlename : null,
        clientAffiliateId: data?.clientAffiliateId
          ? data?.clientAffiliateId
          : null,
        gender: data?.gender,
        dateOfBirth: moment(data?.dateOfBirth).format(
          "YYYY-MM-DDTHH:MM:SS+HH:MM"
        ),
        contactNumber: isDataEmpty(data?.contactNumber)
          ? null
          : data?.contactNumber,
        emails: data?.emails.length === 0 ? null : data?.emails,
        client_ID: clientId,
        medicalRecordNo: isDataEmpty(data?.medicalRecordNo)
          ? null
          : data?.medicalRecordNo,
        cardNumber: isDataEmpty(data?.cardNumber) ? null : data?.cardNumber,
        governmentId: isDataEmpty(data?.governmentId)
          ? null
          : data?.governmentId,
        phAddresses: data?.phAddresses,
      });

      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export { createPatient };
